import { SourcingOpenings } from 'api-clients/monolith';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { EllipsisVertical } from 'lucide-react';
import ExternalLinkIcon from '@/assets/icons/external-link.svg';
import { PlaneSendIcon } from '@/components/icons/plane-send';
import {
  RowDropdownMenu as DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuthContext } from '@/contexts/auth-context';
import { useHireUrl } from '@/hooks/use-hire-url';

interface MenuProps {
  opening: SourcingOpenings;
  onPostJob: (opening: SourcingOpenings) => void;
}

export function Menu({ opening, onPostJob }: MenuProps) {
  const intl = useIntl();
  const { getHireApplicantTableUrl } = useHireUrl();
  const { canPostToJobBoards } = useAuthContext();

  const handlePostJobClick = () => {
    onPostJob(opening);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={intl.formatMessage(
          {
            defaultMessage: 'Opening actions for {opening}',
            description: 'Actions for the job opening named by opening',
          },
          { opening: opening.title },
        )}
      >
        <EllipsisVertical className="text-fx-neutral-600 size-4" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem asChild>
          <Link
            to={getHireApplicantTableUrl(
              opening.brand_slug ?? 'no_brand',
              opening.location_id,
              opening.external_id,
            )}
            target="_blank"
          >
            <img src={ExternalLinkIcon} alt="" />
            <FormattedMessage
              defaultMessage="View in Hire"
              description="Row menu: deep link to applicant pipeline in Hire ATS"
            />
          </Link>
        </DropdownMenuItem>

        {canPostToJobBoards && (
          <DropdownMenuItem onClick={handlePostJobClick}>
            <PlaneSendIcon className="text-fx-neutral-400 size-4" />
            <FormattedMessage
              defaultMessage="Post Job"
              description="Action button label for posting a job to sourcing channels"
            />
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
